import { message, Switch } from "antd";
import React, { useState } from "react";
import { IClient } from "../../pages/Clients";
import { api } from "../../services/api";
import { Input } from "../Input";
import { Modal } from "../Modal";
import { Content } from "./styles";

interface Props {
  title: string;
  confirm: (client: IClient)=> void;
  cancel: ()=> void;
}
export function CreateClientModal({title, confirm, cancel,...rest}: Props) {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [corporateName, setCorporateName] = useState("");
  const [email, setEmail] = useState("");
  const [cpfCnpj, setCpfcnpj] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState(false);
  function create(client:Omit<IClient, 'id'|'createdAt'|'messageCount'|'messageLimit'>) {
    setLoading(true)
    api.post<IClient>('clients',  client).then((response)=>{
      message.success('Cliente cadastrado com sucesso!');
      confirm(response.data)
    }).catch((e)=>{
      message.error(e.response.data.message)
    }).finally(()=> setLoading(false));
  }
  function handleCreateClient() {
    if(!name || !email || !password){
      return message.info('Preencha todos os dados marcados com *');
    }
    create({
      cpfCnpj: cpfCnpj,
      name,
      email,
      password,
      isBlocked: !status,
      corporateName,
    })
  }
  return(
    <Modal
          cancel={cancel}
          confirm={handleCreateClient}
          loading={loading}
          title={title}
        >
          <Content>
            <div className="form-group">
              <span>*Nome:</span>
              <Input placeholder="Digite um nome"   value={name}
                onChange={(ev) => setName(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
              <span>Nome Corporativo:</span>
              <Input placeholder="Digite um nome corporativo"   value={corporateName}
                onChange={(ev) => setCorporateName(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>*Email:</span>
              <Input placeholder="Digite um email"   value={email}
                onChange={(ev) => setEmail(ev.currentTarget.value)} />
            </div>
            <div className="form-group">
              <span>CPF/CNPJ:</span>
              <Input placeholder="Digite um CPF ou CNPJ"    value={cpfCnpj}
                onChange={(ev) => setCpfcnpj(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>*Senha:</span>
              <Input placeholder="Digite uma senha"   value={password} 
              type='password'
                onChange={(ev) => setPassword(ev.currentTarget.value)}/>
            </div>
            <div className="form-group">
              <span>Status:</span>
              <Switch
                checkedChildren="ATIVO"
                unCheckedChildren="INATIVO"
                defaultChecked={status}
                checked={status}
                onChange={(ev)=>{setStatus(ev)}}
                style={{ borderRadius: "8px" }}
              />
            </div>
          </Content>
        </Modal>
      
  )
}
